export default __webpack_public_path__ + "static/media/menu_2.4553143c.png";